export default __webpack_public_path__ + "public/beian.png";